import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./attendancewithgrouping.component.html",
})
export class AttendanceWithGroupingComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		GroupID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ShowDetail: "Yes",
		groupBy: "Group Name",
		ImageLogo: "",
	};
	schoolList: any = [];
	groupList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstShowDetail = [
		{
			ShowDetailDesc: "Yes",
		},
		{
			ShowDetailDesc: "No",
		},
	];
	lstGroupBy = [
		{
			GroupByDesc: "Group Name",
		},
		{
			GroupByDesc: "Academy",
		},
		{
			GroupByDesc: "Homeroom",
		},
		{
			GroupByDesc: "Grade",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 258;

	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(258);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					this.GroupList();
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.GroupList();
		this.loadLogolist();
	}

	private GroupList() {
		this.report.GroupID = 0;
		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length > 1) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				} else {
					this.groupList.push({
						GroupID: 0,
						GroupName: "No Record found",
					});
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//   this.errorMessage = "Select the School";
		//   return
		// }
		// if(!this.report.GroupID){
		// this.errorMessage="Select the GroupName";
		//  return
		// }

		if (String(this.report.ShowDetail).toLowerCase() == "yes") {
			//
			// Only 1 month range allowed for show detail
			//

			//
			// Get difference in miliseconds
			//
			var MsDiff: any = 0;

			var sDate: Date = new Date(moment(this.report.StartDate).format("MM/DD/YYYY"));
			var eDate: Date = new Date(moment(this.report.EndDate).format("MM/DD/YYYY"));

			MsDiff = eDate.getTime() - sDate.getTime();

			//
			// Get difference in days
			//

			var DayDiff: any = MsDiff / 1000 / 60 / 60 / 24;

			if (DayDiff < 0) {
				this.errorMessage = "Start Date must be before End Date";
				return;
			}
			if (DayDiff > 31) {
				this.errorMessage = "If Show Detail is selected you can only select dates that are less than 1 month apart";
				return;
			}
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";

		var StartDate = moment(this.report.StartDate).format("MM/DD/YYYY");
		var EndDate = moment(this.report.EndDate).format("MM/DD/YYYY");

		strParam += "," + StartDate + "|StartDate";
		strParam += "," + EndDate + "|EndDate";
		strParam += ",No|ShowDetail";
		strParam += "," + this.report.groupBy + "|GroupBY";
		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
